import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  Stack,
} from '@mui/material';
import { MeetingRoom } from '../../types/models';

interface RoomDetailModalProps {
  open: boolean;
  onClose: () => void;
  room: MeetingRoom | null;
}

const RoomDetailModal: React.FC<RoomDetailModalProps> = ({ open, onClose, room }) => {
  if (!room) return null;

  // PostgreSQL 배열 문자열을 JavaScript 배열로 변환하는 함수
  const parseEquipment = (equipmentStr: string) => {
    try {
      return equipmentStr
        .replace(/^\{|\}$/g, '') // 앞뒤 중괄호 제거
        .split(',') // 쉼표로 분리
        .map(item => item.trim().replace(/^"|"$/g, '')); // 따옴표 제거 및 공백 제거
    } catch (error) {
      console.error('Equipment 파싱 오류:', error);
      return [];
    }
  };

  const equipmentItems = room.equipment ? parseEquipment(room.equipment).filter(Boolean) : [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 520,
        },
      }}
    >
      <DialogContent sx={{ pt: 2, maxHeight: '70vh' }}>
        {room.image_url && (
          <Box sx={{ mb: 2 }}>
            <img 
              src={room.image_url} 
              alt={room.name} 
              draggable="false"
              style={{ 
                width: '100%', 
                maxHeight: 220,
                objectFit: 'cover',
                borderRadius: '8px'
              }} 
            />
          </Box>
        )}

        <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
          {room.name}
        </Typography>

        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
          <Chip label={`위치 ${room.location}`} size="small" variant="outlined" />
          <Chip label={`수용 ${room.capacity}명`} size="small" variant="outlined" />
        </Stack>

        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {room.description && (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
                설명
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
                {room.description}
              </Typography>
            </Box>
          )}

          {equipmentItems.length > 0 && (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
                시설
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                {equipmentItems.map((item: string, index: number) => (
                  <Chip key={index} label={item} size="small" />
                ))}
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoomDetailModal;
